import api from '../../services/api';

const baseUrl = 'marketing/announcement'

const findByContext = async (context) =>
    api.get({ type: 'user', service: `${baseUrl}/context/${context}` });

const markViewed = async (announcementId) =>
    api.post({ type: 'user', service: `${baseUrl}/${announcementId}/mark-viewed` });

const markViewedByKey = async (announcementKey, additionalInformation = null) =>
    api.post({ type: 'user', service: `${baseUrl}/${announcementKey}/mark-viewed-key`, data: { additionalInformation } });

const getAnnouncementAllowedDisplay = async (announcementKey, customerId, requestId = null) =>
    api.post({ type: 'user', service: `${baseUrl}/${announcementKey}/allowed-display`, data: { customerId, requestId } });

const getPlatformUpdateDisplayStatus = async (announcementKey) =>
    api.get({ type: 'user', service: `${baseUrl}/${announcementKey}/platform-update-display-status` });

const dismissPlatformUpdateModal = async () =>
    api.post({ type: 'user', service: `${baseUrl}/platform-update-dismiss` });

export default {
    markViewed,
    markViewedByKey,
    getAnnouncementAllowedDisplay,
    getPlatformUpdateDisplayStatus,
    dismissPlatformUpdateModal,
    findByContext,
}